import * as React from 'react';
import DocumentHeader from 'Components/DocumentHeader';
import DocumentWrapper from 'Components/DocumentWrapper';
import FormEditingHandler from 'Containers/FormEditingHandler';
import PulmonaryForm from './Form';
import ChestCircumferenceHistory from './HistoryRowData/ChestCircumference';
import PulmonaryHistory from './HistoryRowData/Pulmonary';
import VentilationHistory from './HistoryRowData/Ventilation';
import { filterByDocumentType } from 'Utility/documentHandling';
import type { TPulmonaryDocumentType } from '../utils';

const History = (
  documents: Array<IDocumentWithTypeV2<TPulmonaryDocumentType>>,
  startEdit: StartEdit,
): React.JSX.Element => {
  const chestCircumferenceDocs = filterByDocumentType(documents, 'chestCircumference');
  const ventilationDocs = filterByDocumentType(documents, 'ventilationAid');
  const pulmonaryDocs = filterByDocumentType(documents, 'pulmonary');

  return (
    <React.Fragment>
      <ChestCircumferenceHistory documents={chestCircumferenceDocs} startEdit={startEdit} />
      <VentilationHistory documents={ventilationDocs} startEdit={startEdit} />
      <PulmonaryHistory documents={pulmonaryDocs} startEdit={startEdit} />
    </React.Fragment>
  );
};

const Pulmonary = ({ documents }: IOwnProps): React.JSX.Element => {
  return (
    <FormEditingHandler name="pulmonary" documents={documents}>
      {(editing, startEdit, formData, view): React.JSX.Element => {
        const currentDocument = documents.find(d => d._id === editing);
        const type = currentDocument?._type;
        return (
          <DocumentWrapper>
            <DocumentHeader
              name="pulmonary"
              headerId={
                type
                  ? {
                      chestCircumference: 'pulmonary.chestCircumference',
                      ventilationAid: 'pulmonary.ventilation',
                      pulmonary: 'pulmonary.airwayClearanceorSecretionMobilisation',
                    }[type]
                  : 'pulmonary.title'
              }
              editing={editing}
              editButtons={<div />}
            />
            {editing ? <PulmonaryForm formData={formData} documents={documents} editing={editing} /> : null}
            {!editing && !view?.viewing ? History(documents, startEdit) : undefined}
          </DocumentWrapper>
        );
      }}
    </FormEditingHandler>
  );
};

interface IOwnProps {
  documents: Array<IDocumentWithTypeV2<TPulmonaryDocumentType>>;
}

export default Pulmonary;
